module.exports = __webpack_public_path__ + "img/horizontal_6_7_5010.768b6b85.png";